import { bootstrapApplication } from '@angular/platform-browser'

import * as Sentry from '@sentry/angular'

import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'

// Replaced during Docker build to align the runtime release with uploaded sourcemaps.
const sentryRelease = '5e7b0ff7725f99a54a8393739b8f01dc408c7849'

Sentry.init({
  dsn: 'https://c40c1fd2151397484944db64dbd676f1@sentry.dccprod.nl/95',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.feedbackIntegration({
      showBranding: false,
      colorScheme: 'light',
    }),
  ],
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
  enableLogs: true,
  release: sentryRelease.startsWith('__SENTRY_RELEASE_')
    ? '000000'
    : sentryRelease,
})

bootstrapApplication(AppComponent, appConfig).catch((err: unknown) => {
  console.error(err)
})
